import React, { Component } from 'react';
import { connect } from 'react-redux';
import './index.scss';
import Banner from './component/banner';
import Placeholder from './component/placeHolder';
import Counter from './component/counter/counter';
import HoverCard from './component/hoverCard/hoverCard';
import Card from './component/card/card';
import SlickComponent from './component/slick/slick';
import SlickOne from './component/slickOne/index';
import { actionCreators } from './store';

class Home extends Component {

  componentDidMount() {
    this.props.fetchHomePageData();
  }

  render() {

    const { doctor, partner } = this.props;

    return (
      <div className="home-page">
        <Banner />
        <div className="home-page__content">
          <Counter></Counter>
          <HoverCard hoverCardData={ doctor } title="技术专家"></HoverCard>
          <SlickOne></SlickOne>
          <Card></Card>
          <SlickComponent></SlickComponent>
          <Placeholder title="合作单位" picUrl={ partner.get('logo') } />
        </div>
      </div>
    )
  }
}

const mapState = (state) => ({
  doctor: state.getIn(['home', 'doctor']),
  partner: state.getIn(['home', 'partner'])
});

const mapDisPatchToProps = (dispatch) => ({
  fetchHomePageData() {
    dispatch(actionCreators.fetchHomePageData());
  }
});

export default connect(mapState, mapDisPatchToProps)(Home);